import { deleteSuperVoice, SuperVoiceItemDTO } from '@/service/generatorv2';
import { cn } from '@/utils';
import { Button } from '@jenmusic/jen-ui-library';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSuperVoiceList } from '../hooks';
import { differenceInMinutes, format } from 'date-fns';
import { useEffect, useState } from 'react';
import { Dialog } from '@/components/Dialog';
import { toast } from 'sonner';

export const SuperVoiceList = () => {
  const { superVoiceList } = useSuperVoiceList();
  const navigate = useNavigate();

  // const superVoiceList: SuperVoiceItemDTO[] = [
  //   {
  //     id: 12,
  //     name: 'SuperVoice 1',
  //     created_at: '2025-05-15T03:12:43.421Z',
  //     status: 'success',
  //     url: 'https://cdn.jenmusic.com/super_voice/1.mp3',
  //   },
  //   {
  //     id: 2,
  //     name: 'SuperVoice 2',
  //     created_at: '2025-05-15T03:12:43.421Z',
  //     status: 'uploading',
  //     url: 'https://cdn.jenmusic.com/super_voice/2.mp3',
  //   },
  // ];

  return (
    <div className="py-9">
      <div className="px-6  typography-jenmusic-heading-medium mb-2 text-jenmusic-content-primary w-[128px]">SuperVoice Filter Beta</div>
      <div className="px-6  typography-jenmusic-base mb-9 text-jenmusic-content-tertiary">
        Create a filter that you can then use to change the voice used in another track.
      </div>
      {!!superVoiceList?.length && (
        <div className="mb-8">
          {superVoiceList.map((item) => (
            <SuperVoiceItem
              key={item.id}
              item={{ ...item, sideWord: 'REMOVE' }}
              onClickMain={(id) => navigate(`/super_voice/create/${id}`)}
              onClickRemove={async (id) => {
                console.log('remove', id);
                await Dialog.confirm({
                  title: 'Remove SuperVoice Filter?',
                  description: 'Are you sure you want to remove.',
                  successWord: 'Remove',
                  cancelWord: 'Cancel',
                });
                try {
                  await deleteSuperVoice(id);
                  toast.success('Remove SuperVoice Filter success');
                } catch (error) {
                  toast.error('Remove SuperVoice Filter failed');
                }
              }}
            />
          ))}
        </div>
      )}
      <div className="px-6 ">
        <Button className=" gap-1 w-full h-[52px]" onClick={() => navigate('/super_voice/create')}>
          <Plus width={16} />
          New SuperVoice Filter
        </Button>
      </div>
    </div>
  );
};

export const SuperVoiceItem = ({
  item,
  onClickMain,
  onClickRemove,
}: {
  item: SuperVoiceItemDTO & { sideWord?: string; mainWord?: string };
  onClickMain: (id: number) => void;
  onClickRemove?: (id: number) => void;
}) => {
  const isSuccess = item.status === 'success';
  const [now, setNow] = useState(new Date());
  // reset now every 10 seconds to get the latest progress
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, 10000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div
      className={cn(' px-6 py-4 flex gap-[17px]', {
        // ' bg-jenmusic-background-secondary ': !isSuccess,
      })}
    >
      <div
        className="w-[48px] h-[74px] rounded-[4px] bg-[#000] flex items-center justify-center"
        style={{
          boxShadow:
            '18px 29px 9px 0px rgba(0, 0, 0, 0.00), 11px 18px 9px 0px rgba(0, 0, 0, 0.03), 6px 10px 7px 0px rgba(0, 0, 0, 0.09), 3px 5px 5px 0px rgba(0, 0, 0, 0.16), 1px 1px 3px 0px rgba(0, 0, 0, 0.19)',
        }}
      >
        {isSuccess ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path
              d="M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17C14.3137 17 17 14.3137 17 11C17 7.68629 14.3137 5 11 5ZM11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7Z"
              fill="white"
            />
          </svg>
        ) : (
          <svg className=" animate-spin-slow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_10012_33451)">
              <path d="M12 2.00098V6.00098" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M16.1997 7.80039L19.0997 4.90039"
                stroke="white"
                stroke-width="2.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M18 12H22" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M16.1997 16.1992L19.0997 19.0992"
                stroke="white"
                stroke-width="2.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M12 18V22" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.8999 19.0992L7.7999 16.1992" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2 12H6" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.8999 4.90039L7.7999 7.80039" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_10012_33451">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        )}
      </div>
      <div className="flex-grow flex flex-col justify-between ">
        <div>
          <div className=" mb-2 text-jenmusic-content-tertiary text-[20px] tracking-[-0.8px] leading-[20px]">{item.name}</div>

          <div className="   text-[12px] leading-[16px]">
            {isSuccess ? (
              <span className=" text-jenmusic-content-tertiary">{format(new Date(item.created_at), 'MMM dd yyyy')}</span>
            ) : (
              <span className="text-jenmusic-interactive uppercase">
                Jenerating . . .{' '}
                {(() => {
                  const created = new Date(item.created_at);
                  const diffMinutes = differenceInMinutes(now, created);
                  const percentage = Math.min(Math.floor((diffMinutes / 60) * 100), 99);
                  return `${percentage}%`;
                })()}
              </span>
            )}
          </div>
        </div>

        <div className="flex justify-between font-jenmusic-GT text-[12px] leading-[15px]">
          <div
            onClick={() => {
              console.log('isSuccess', isSuccess);
              isSuccess && onClickMain?.(item.id);
            }}
            className={cn(isSuccess ? 'text-jenmusic-interactive' : 'text-jenmusic-disabled', {
              'cursor-pointer': isSuccess,
            })}
          >
            {item.mainWord || 'CREATE A TRACK'}
          </div>
          <div
            onClick={() => isSuccess && !!item.sideWord && onClickRemove?.(item.id)}
            className={cn('text-jenmusic-content-tertiary', {
              'cursor-pointer': isSuccess && !!item.sideWord,
            })}
          >
            {item.sideWord}
          </div>
        </div>
      </div>
    </div>
  );
};
